import { Box, Divider, Grid2, Typography, useTheme } from '@mui/material';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import { FC, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { TCategoryStore } from '../../../../Services/api/categories/categories.interface';
import { IImportOrderPayload } from '../../../../Services/api/orders/orders.interface';
import { TStoreType } from '../../../../Services/api/service-orders/service-order.interface';
import { Button } from '../../../Form/Button/button.scomponent';
import { Input } from '../../../Form/Input/input.component';
import { Radio } from '../../../Form/Radio/radio-input.component';


interface IDrawerComponent extends DrawerProps {
  onToggle: (state: boolean) => void;
  title: string;
  subTitle?: string;
  search?: boolean;
  searchFunction?: () => void;
  titleStyle?: object;
  subTitleStyle?: object;
  open: boolean;
  handleSelect: (payload: IImportOrderPayload) => void;
}

const ImportOrderDrawer: FC<IDrawerComponent> = ({
  onToggle,
  title,
  subTitle,
  open,
  titleStyle = {},
  subTitleStyle = {},
  handleSelect,
}) => {
  const theme = useTheme();
  const { control, handleSubmit, register, formState: { errors }, reset } = useForm({
    defaultValues: {
      orderId: '',
      store: 'B2B'
    }
  });

  useEffect(() => {
    if (!open) {
      reset({
        orderId: '',
        store: 'B2B'
      });
    }
  }, [open, reset]);

  const handleFilterSubmit = handleSubmit((data) => {
    const storeValue = data.store as TStoreType || 'B2B';
    handleSelect({ orderId: data.orderId, store: storeValue });
    onToggle(false);
  });

  return (
    <Drawer
      open={open}
      onClose={onToggle}
      anchor="right"
      style={{ zIndex: 99999999, flex: 1 }}
    >
      <Grid2 container sx={{ minWidth: '540px', padding: '30px 30px', height: '100%', flex: 1, position: 'relative' }}>
        {/* Conteúdo do Drawer */}
        <Grid2 size={12}>
          <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', ...titleStyle }}>
            {title}
          </Typography>
          {subTitle && (
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: '400',
                color: theme.palette.text.secondary,
                ...subTitleStyle,
              }}
            >
              {subTitle}
            </Typography>
          )}
          <Divider sx={{ marginTop: '20px', marginBottom: '40px' }} />
       
          <Input
            label='Número do Pedido'
            {...register('orderId', { 
              required: 'Número do pedido é obrigatório' 
            })}
            placeholder='Digite o número do pedido'
            error={!!errors.orderId}
            helperText={errors.orderId?.message as string}
          />
          
          <Grid2 size={12} sx={{ marginTop: '20px' }}>
            <Radio
              label='Tipo de Loja'
              name='store'
              control={control}
              defaultValue='B2B'
              options={[
                { label: 'B2B', value: 'B2B' },
                { label: 'B2C', value: 'B2C' },
              ]}
            />
          </Grid2>
        </Grid2>

        {/* Footer */}
        <Box
          sx={{
            position: 'absolute',
            bottom: '40px',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <Grid2 container spacing={2} justifyContent="flex-end">
            <Grid2>
              <Button variant="outlined" onClick={() => onToggle(false)} sx={{ width: '120px'}}>
                Cancelar
              </Button>
            </Grid2>
            <Grid2>
              <Button variant="contained" onClick={handleFilterSubmit} sx={{ width: '120px'}}>
                Importar
              </Button>
            </Grid2>
          </Grid2>
        </Box>
      </Grid2>
    </Drawer>
  );
};

export { ImportOrderDrawer };
